import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button'
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCommonModule, MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatDividerModule } from '@angular/material/divider';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { FormsModule } from '@angular/forms';
import { ReactiveFormsModule } from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatSidenavModule, MatSidenavContainer } from '@angular/material/sidenav';
import { MatExpansionModule } from '@angular/material/expansion';

//import {  } from '@angular/material/expansion';

const material = [DragDropModule, MatAutocompleteModule, MatDividerModule, MatButtonToggleModule, MatTooltipModule, CommonModule, MatNativeDateModule,
  MatDatepickerModule, MatRadioModule, MatCheckboxModule, MatOptionModule, MatSelectModule, MatPaginatorModule, MatSortModule,
  MatTableModule, MatDialogModule, MatMenuModule, MatIconModule, MatCommonModule, MatButtonModule, MatToolbarModule, MatInputModule,
  MatProgressSpinnerModule, MatFormFieldModule, MatCardModule, FormsModule, ReactiveFormsModule, MatSidenavModule, MatExpansionModule, MatSidenavContainer];
@NgModule({
  exports: [material],
  imports: [material]
})
export class MaterialModule { }